// extracted by mini-css-extract-plugin
export default {"EmployeeFormModal":"EmployeeFormModal_EmployeeFormModal__yX6YG"};